module.exports = (__webpack_require__(8))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/classnames/index.js from dll-reference __vendor
// module id = 75
// module chunks = 0